// Globals
import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { Link } from 'react-router-dom';

// Models
import { IBaseLLMTemplate } from '@/models/llmTemplate.model';

// Components
import { Button } from '@/ui';
import { PenIcon } from '@/icons';

// Constants
import { ROUTES } from '@/constants/routes';
import { DateFormats } from '@/constants/dates';

// Helpers
import { renderDate } from '@/utils';

export const getLLMTemplatesColumns = (t: TFunction): TableColumnsType<IBaseLLMTemplate> => [
  {
    dataIndex: 'channelType',
    key: 'channelType',
    title: t('column_type'),
    render: (channelType: IBaseLLMTemplate['channelType']) => channelType,
  },
  {
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    title: t('column_update_date'),
    render: (updatedAt: string) => renderDate(updatedAt, DateFormats.DATE_WITH_TIME),
  },
  {
    title: t('column_action'),
    key: 'action',
    width: 80,
    render: (_, record) => (
      <Link to={`${ROUTES.LLM_TEMPLATES}/${record.channelType}`}>
        <Button icon={<PenIcon />} type="primary" size="small" block>
          {t('btn_edit')}
        </Button>
      </Link>
    ),
  },
];
